/**
 * Hilo 落地页脚本（PC / 移动端共用）
 * 依赖：swiper-bundle.min.js、lazyload.min.js
 * 含：sec10 轮播、tray 轮播、喷嘴轮播、kv16 手风琴 / 移动端 Swiper、s23（kv18）卡片轮播
 */
(function () {
  if (window.__HILO__) {
    return;
  }
  window.__HILO__ = true;
  window.HILO_BP_PC = 981;

  var PLACEHOLDER =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
  var lazyDone = false;

  /** 轮播根节点选择器（兼容历史类名 sec1family） */
  var CAROUSEL_EL_SEL = '.sec10family, .sec1family';

  /** 无 src 的图片先占位，避免布局塌陷 */
  document.querySelectorAll('#main-content img:not([src])').forEach(function (img) {
    img.setAttribute('src', PLACEHOLDER);
  });

  /**
   * 脚本加载后立即关闭轮播内 video 的 HTML autoplay
   * 仅作用于 .swiper-slide 内视频，不影响页面其他独立 video
   */
  function prepCarouselVideos(root) {
    root = root || document.getElementById('main-content');
    if (!root) {
      return;
    }
    root.querySelectorAll('.swiper-slide video').forEach(function (video) {
      video.removeAttribute('autoplay');
      video.autoplay = false;
      video.pause();
    });
  }
  prepCarouselVideos();

  /** 查找轮播容器内的 Swiper 根节点 */
  function getCarouselEl(container) {
    return container ? container.querySelector(CAROUSEL_EL_SEL) : null;
  }

  /**
   * 立即加载指定 slide 内的懒加载媒体
   * 轮播首屏不等待 LazyLoad 进入视口，避免初始化时高度为 0
   * @param {Function} [onReady] 单张图片 decode/load 完成后的回调
   */
  function loadSlideMedia(slide, onReady) {
    if (!slide) {
      return;
    }

    slide.querySelectorAll('img[data-cbcn-src]').forEach(function (img) {
      var src = img.getAttribute('data-cbcn-src');
      if (!src) {
        return;
      }
      var current = img.getAttribute('src');
      if (!current || current === PLACEHOLDER) {
        img.setAttribute('src', src);
        if (onReady) {
          if (img.decode) {
            img.decode().then(onReady).catch(onReady);
          } else {
            img.addEventListener(
              'load',
              function handler() {
                img.removeEventListener('load', handler);
                onReady();
              },
              { once: true }
            );
          }
        }
      }
      var srcset = img.getAttribute('data-cbcn-srcset');
      if (srcset && !img.getAttribute('srcset')) {
        img.setAttribute('srcset', srcset);
      }
    });

    slide.querySelectorAll('video').forEach(function (video) {
      var source = video.querySelector('source[data-cbcn-src]');
      if (!source) {
        return;
      }
      var src = source.getAttribute('data-cbcn-src');
      if (!src) {
        return;
      }
      if (!source.getAttribute('src')) {
        source.setAttribute('src', src);
        video.load();
        /** 预加载时不播放，由 syncVideos 控制当前 slide */
        video.pause();
        if (onReady) {
          video.addEventListener('loadeddata', onReady, { once: true });
        }
      }
    });
  }

  /** kv10 等纯图片轮播：预加载全部 slide，避免切换时高度跳动 */
  function preloadAllCarouselSlides(el, onImageReady) {
    if (!el) {
      return;
    }
    el.querySelectorAll('.swiper-slide').forEach(function (slide) {
      loadSlideMedia(slide, onImageReady);
    });
  }

  /** 预加载当前及相邻 slide 媒体，减少切换时高度跳动 */
  function preloadCarouselMedia(sw) {
    if (!sw || !sw.slides || !sw.slides.length) {
      return;
    }
    var idx = sw.activeIndex;
    [idx - 1, idx, idx + 1].forEach(function (i) {
      if (i >= 0 && i < sw.slides.length) {
        loadSlideMedia(sw.slides[i]);
      }
    });
  }

  /** 与 liquid 中 .wap / .pc 切换断点一致 */
  function isMobileView() {
    return window.innerWidth <= 768;
  }

  /** 当前视口下该 video 是否应展示（pc / wap 面板或 video 自身 class） */
  function isVideoVisibleInViewport(video) {
    if (!video) {
      return false;
    }
    if (video.classList.contains('pc')) {
      return !isMobileView();
    }
    if (video.classList.contains('wap')) {
      return isMobileView();
    }
    var panel = video.closest('.protection-pc, .protection-wap');
    if (panel) {
      if (panel.classList.contains('protection-pc')) {
        return !isMobileView();
      }
      if (panel.classList.contains('protection-wap')) {
        return isMobileView();
      }
    }
    return true;
  }

  /**
   * 轮播内视频：仅当前 slide + 当前视口可见的那一个播放
   * @param {HTMLElement} swiperEl Swiper 根节点
   * @param {number} activeIndex 当前选中 slide 索引
   */
  function syncVideos(swiperEl, activeIndex) {
    if (!swiperEl) {
      return;
    }

    swiperEl.querySelectorAll('.swiper-slide').forEach(function (slide, i) {
      var isActive = i === activeIndex;
      if (isActive) {
        loadSlideMedia(slide);
      }

      slide.querySelectorAll('video').forEach(function (video) {
        var shouldPlay = isActive && isVideoVisibleInViewport(video);
        if (shouldPlay) {
          var tryPlay = function () {
            var p = video.play();
            if (p && p.catch) {
              p.catch(function () {});
            }
          };
          if (video.readyState >= 2) {
            tryPlay();
          } else {
            video.addEventListener('loadeddata', tryPlay, { once: true });
            video.addEventListener('canplay', tryPlay, { once: true });
          }
        } else {
          video.pause();
        }
      });
    });
  }

  /**
   * 拦截非当前 slide 的意外 play（LazyLoad / preload 等触发）
   * @param {HTMLElement} swiperEl Swiper 根节点
   * @param {Function} getActiveIndex 返回当前 activeIndex
   */
  function guardVideoPlayback(swiperEl, getActiveIndex) {
    if (!swiperEl) {
      return;
    }

    swiperEl.querySelectorAll('video').forEach(function (video) {
      if (video.dataset.t1Guard) {
        return;
      }
      video.dataset.t1Guard = '1';
      video.removeAttribute('autoplay');
      video.autoplay = false;

      video.addEventListener('play', function () {
        var idx = getActiveIndex();
        if (idx == null || idx < 0) {
          video.pause();
          return;
        }
        var slide = video.closest('.swiper-slide');
        if (!slide) {
          return;
        }
        var slides = swiperEl.querySelectorAll('.swiper-slide');
        var slideIndex = Array.prototype.indexOf.call(slides, slide);
        if (slideIndex !== idx || !isVideoVisibleInViewport(video)) {
          video.pause();
        }
      });
    });
  }

  /**
   * kv4 / kv8 / kv10 等纯图片轮播：需预加载全部 slide 才能正确计算高度
   * kv8 与 cplus // 18（tray）一样依赖真实媒体尺寸撑开，不能只预加载首张
   */
  function isImagePreloadCarousel(container) {
    return !!(container && container.closest('.kv4, .kv8, .kv10, .kv14'));
  }

  /** 取当前视口下实际展示的 slide 内容面板（pc 或 wap） */
  function getVisibleSlidePanel(slide) {
    if (!slide) {
      return null;
    }
    var selector = isMobileView() ? '.protection-wap' : '.protection-pc';
    return slide.querySelector(selector) || slide;
  }

  /** 测量单个 slide 在当前视口下的内容高度 */
  function measureSlideHeight(slide) {
    var panel = getVisibleSlidePanel(slide);
    if (!panel) {
      return 0;
    }
    return panel.getBoundingClientRect().height;
  }

  /**
   * 移动端 sec-10（kv8 类）：统一各 slide 标题 / 描述 min-height
   * 文案长短不同时底部文案区域高度对齐
   */
  function equalizeSec10TextAreas(sw) {
    if (!sw || !sw.slides || !isMobileView()) {
      return;
    }

    var titles = [];
    var descs = [];

    sw.slides.forEach(function (slide) {
      var wap = slide.querySelector('.protection-wap');
      if (!wap) {
        return;
      }
      var title = wap.querySelector('.title');
      var desc = wap.querySelector('.description');
      if (title) {
        title.style.minHeight = '';
        titles.push(title);
      }
      if (desc) {
        desc.style.minHeight = '';
        descs.push(desc);
      }
    });

    var maxTitle = 0;
    var maxDesc = 0;
    titles.forEach(function (el) {
      maxTitle = Math.max(maxTitle, el.offsetHeight);
    });
    descs.forEach(function (el) {
      maxDesc = Math.max(maxDesc, el.offsetHeight);
    });

    if (maxTitle > 0) {
      titles.forEach(function (el) {
        el.style.minHeight = Math.ceil(maxTitle) + 'px';
      });
    }
    if (maxDesc > 0) {
      descs.forEach(function (el) {
        el.style.minHeight = Math.ceil(maxDesc) + 'px';
      });
    }
  }

  /**
   * 计算轮播容器应有高度
   * - PC：只量当前激活 slide
   * - 移动端 sec-10：取全部 slide 最高，配合文案区等高，保证底边对齐
   */
  function getCarouselContentHeight(sw, el) {
    if (!sw || !sw.slides || !sw.slides.length) {
      return 0;
    }

    var equalizeMobile =
      isMobileView() && el && el.closest && el.closest('.sec-10');

    if (equalizeMobile) {
      var maxH = 0;
      for (var i = 0; i < sw.slides.length; i++) {
        maxH = Math.max(maxH, measureSlideHeight(sw.slides[i]));
      }
      return maxH;
    }

    return measureSlideHeight(sw.slides[sw.activeIndex]);
  }

  /**
   * sec-10 高度同步 + overflow:visible（不裁切 1.2 张预览）
   * 移动端先统一文案区高度，再按最高卡片写容器 minHeight
   */
  function fixCarouselHeight(sw, el) {
    if (!sw || !el) {
      return;
    }

    el.style.height = 'auto';
    el.style.minHeight = '';
    el.style.overflow = 'visible';

    if (sw.wrapperEl) {
      sw.wrapperEl.style.height = 'auto';
      sw.wrapperEl.style.overflow = 'visible';
    }

    sw.slides.forEach(function (slide) {
      slide.style.height = 'auto';
      var panel = getVisibleSlidePanel(slide);
      if (panel && panel !== slide) {
        panel.style.height = '';
        panel.style.minHeight = '';
      }
      /** 避免 CSS height:100% 在图片未加载时导致高度塌陷 */
      slide.querySelectorAll('img').forEach(function (img) {
        img.style.height = 'auto';
      });
    });

    // 移动端 sec-10：统一标题/描述高度后，再量整卡并等高
    if (isMobileView() && el.closest && el.closest('.sec-10')) {
      equalizeSec10TextAreas(sw);
      sw.update();
      // 文案区拉齐后高度会变，再同步一次
      equalizeSec10TextAreas(sw);
    } else {
      sw.update();
    }

    var h = getCarouselContentHeight(sw, el);
    if (h > 0) {
      var ceilH = Math.ceil(h);
      el.style.minHeight = ceilH + 'px';

      // 移动端 sec-10：所有 slide 拉成同一高度，卡片底边对齐
      if (isMobileView() && el.closest && el.closest('.sec-10')) {
        sw.slides.forEach(function (slide) {
          slide.style.height = ceilH + 'px';
          var panel = getVisibleSlidePanel(slide);
          if (panel && panel !== slide) {
            panel.style.height = '100%';
            panel.style.minHeight = ceilH + 'px';
            panel.style.boxSizing = 'border-box';
          }
        });
      }
    }

    el.style.overflow = 'visible';
    if (sw.wrapperEl) {
      sw.wrapperEl.style.overflow = 'visible';
    }
  }

  /** 监听 slide 尺寸变化（媒体加载后自动重算高度） */
  function observeCarouselResize(container, sw, el) {
    if (!window.ResizeObserver || !sw || !el) {
      return;
    }

    if (container._t1ResizeObs) {
      container._t1ResizeObs.disconnect();
    }

    var timer = null;
    var ro = new ResizeObserver(function () {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(function () {
        fixCarouselHeight(sw, el);
      }, 16);
    });

    sw.slides.forEach(function (slide) {
      ro.observe(slide);
      var panel = getVisibleSlidePanel(slide);
      if (panel && panel !== slide) {
        ro.observe(panel);
      }
    });

    container._t1ResizeObs = ro;
  }

  /** 绑定轮播内媒体 load 事件，加载完成后刷新高度 */
  function bindCarouselMediaEvents(sw, el) {
    var resize = function () {
      fixCarouselHeight(sw, el);
    };

    el.querySelectorAll('img, video').forEach(function (media) {
      media.addEventListener('load', resize);
      media.addEventListener('loadeddata', resize);
      media.addEventListener('loadedmetadata', resize);
    });
  }

  /** 懒加载 */
  function initLazy() {
    if (lazyDone || typeof LazyLoad === 'undefined') {
      return;
    }
    lazyDone = true;

    function onEnter(node) {
      var box = node.closest('.carousel-container');
      if (box && box._t1Swiper) {
        var carouselEl = getCarouselEl(box);
        if (carouselEl) {
          fixCarouselHeight(box._t1Swiper, carouselEl);
          syncVideos(carouselEl, box._t1Swiper.activeIndex);
        }
      }
      var tray = node.closest('.tray-container');
      if (tray && tray._t1Swiper) {
        var trayEl = tray.querySelector('.tray-swiper');
        if (trayEl) {
          syncVideos(trayEl, tray._t1Swiper.activeIndex);
        }
      }
      var nozzleBox = node.closest('.t1-container-nozzle');
      if (nozzleBox && nozzleBox._t1Swiper) {
        var nozzleEl = nozzleBox.querySelector('.t1-nozzle');
        if (nozzleEl) {
          syncVideos(nozzleEl, nozzleBox._t1Swiper.activeIndex);
        }
      }
    }

    new LazyLoad({
      elements_selector: '#main-content img',
      data_src: 'cbcn-src',
      data_srcset: 'cbcn-srcset',
      threshold: '3000',
      callback_enter: onEnter,
    });
    new LazyLoad({
      elements_selector: '#main-content video',
      data_src: 'cbcn-src',
      data_srcset: 'cbcn-srcset',
      data_poster: 'cbcn-poster',
      threshold: '3000',
      callback_enter: onEnter,
    });
  }

  /** sec-10：每个 .carousel-container 内轮播独立实例 */
  function initCarousel(container) {
    if (container.dataset.t1Carousel) {
      return;
    }

    var el = getCarouselEl(container);
    if (!el) {
      return;
    }

    if (!el.classList.contains('swiper')) {
      el.classList.add('swiper');
    }
    el.style.height = 'auto';
    el.style.overflow = 'visible';

    prepCarouselVideos(el.closest('#main-content') || document.getElementById('main-content'));

    if (el.swiper) {
      el.swiper.destroy(false, false);
    }

    if (container._t1ResizeObs) {
      container._t1ResizeObs.disconnect();
      container._t1ResizeObs = null;
    }

    var isImageCarousel = isImagePreloadCarousel(container);
    /** kv8：对齐 cplus_pc_product.js // 18（tray-swiper）的 slidesPerView 断点，减少高度被邻张撑高 */
    var isKv8 = !!(container.closest && container.closest('.kv8'));

    var pagination = container.querySelector('.sec10ok');
    var opts = {
      direction: 'horizontal',
      speed: 800,
      // kv8 默认 1 张（同 // 18）；其它 sec10 仍用 1.2 露出下一张
      slidesPerView: isKv8 ? 1 : 1.2,
      spaceBetween: isKv8 ? 10 : 20,
      breakpoints: isKv8
        ? {
            // 以下配置复制自 cplus_pc_product.js // 18 begin（tray-swiper）
            320: { slidesPerView: 1.2, spaceBetween: 10 },
            768: { slidesPerView: 1, spaceBetween: 10 },
            1024: { slidesPerView: 1, spaceBetween: 20 },
          }
        : {
            320: { slidesPerView: 1.2, spaceBetween: 10 },
            768: { slidesPerView: 1.2, spaceBetween: 10 },
            1024: { slidesPerView: 1, spaceBetween: 20 },
          },
      on: {
        init: function () {
          preloadCarouselMedia(this);
          fixCarouselHeight(this, el);
          syncVideos(el, this.activeIndex);
        },
        slideChange: function () {
          preloadCarouselMedia(this);
          syncVideos(el, this.activeIndex);
        },
        slideChangeTransitionEnd: function () {
          var swiper = this;
          loadSlideMedia(swiper.slides[swiper.activeIndex], function () {
            fixCarouselHeight(swiper, el);
          });
          fixCarouselHeight(swiper, el);
          syncVideos(el, swiper.activeIndex);
        },
      },
    };

    if (pagination) {
      opts.pagination = { el: pagination, clickable: true, dynamicBullets: false };
    }

    var sw = new Swiper(el, opts);
    container._t1Swiper = sw;

    guardVideoPlayback(el, function () {
      return sw.activeIndex;
    });

    /** kv4 / kv10 预加载全部图片；其他轮播仅预加载首张 */
    var scheduleHeightFix = function () {
      fixCarouselHeight(sw, el);
    };
    if (isImageCarousel) {
      preloadAllCarouselSlides(el, scheduleHeightFix);
    } else {
      loadSlideMedia(el.querySelector('.swiper-slide'), scheduleHeightFix);
    }

    var prev = container.querySelector('.sec10family-prev');
    var next = container.querySelector('.sec10family-next');
    if (prev) {
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        sw.slidePrev();
      });
    }
    if (next) {
      next.addEventListener('click', function (e) {
        e.preventDefault();
        sw.slideNext();
      });
    }

    bindCarouselMediaEvents(sw, el);
    observeCarouselResize(container, sw, el);

    preloadCarouselMedia(sw);
    fixCarouselHeight(sw, el);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        fixCarouselHeight(sw, el);
      });
    });
    syncVideos(el, sw.activeIndex);

    container.dataset.t1Carousel = '1';

    /** 横竖屏 / 窗口缩放后按当前 pc/wap 面板重新量高 */
    if (!container._t1ResizeBound) {
      container._t1ResizeBound = true;
      window.addEventListener('resize', function () {
        if (container._t1Swiper) {
          fixCarouselHeight(container._t1Swiper, el);
          syncVideos(el, container._t1Swiper.activeIndex);
        }
      });
    }
  }

  /** tray：每个 .tray-container 独立 Tab + 轮播 */
  function initTray(tray) {
    if (tray.dataset.t1Tray) {
      return;
    }

    var el = tray.querySelector('.tray-swiper');
    if (!el) {
      return;
    }

    if (!el.classList.contains('swiper')) {
      el.classList.add('swiper');
    }
    prepCarouselVideos(el.closest('#main-content') || document.getElementById('main-content'));

    if (el.swiper) {
      el.swiper.destroy(false, false);
    }

    var tabs = tray.querySelectorAll('.tray-tab-button');
    var descs = tray.querySelectorAll('.tray-text-desc[data-desc]');

    function setTrayState(index) {
      tabs.forEach(function (btn, i) {
        btn.classList.toggle('active', i === index);
      });
      descs.forEach(function (panel) {
        panel.classList.toggle('active', Number(panel.dataset.desc) === index);
      });
      syncVideos(el, index);
    }

    var sw = new Swiper(el, {
      direction: 'horizontal',
      speed: 800,
      slidesPerView: 1,
      spaceBetween: 10,
      breakpoints: {
        320: { slidesPerView: 1.2, spaceBetween: 10 },
        768: { slidesPerView: 1, spaceBetween: 10 },
        1024: { slidesPerView: 1, spaceBetween: 20 },
      },
      on: {
        slideChange: function () {
          setTrayState(this.activeIndex);
        },
      },
    });
    tray._t1Swiper = sw;

    guardVideoPlayback(el, function () {
      return sw.activeIndex;
    });

    tabs.forEach(function (btn, i) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var idx = parseInt(btn.getAttribute('data-tab'), 10);
        sw.slideTo(isNaN(idx) ? i : idx);
      });
    });

    setTrayState(sw.activeIndex);
    tray.dataset.t1Tray = '1';

    if (!tray._t1ResizeBound) {
      tray._t1ResizeBound = true;
      window.addEventListener('resize', function () {
        if (tray._t1Swiper) {
          syncVideos(el, tray._t1Swiper.activeIndex);
        }
      });
    }
  }

  /** 喷嘴轮播：仅当前 slide 播放视频 */
  function initNozzle(box) {
    if (box.dataset.t1Nozzle) {
      return;
    }

    var el = box.querySelector('.t1-nozzle');
    if (!el) {
      return;
    }

    if (!el.classList.contains('swiper')) {
      el.classList.add('swiper');
    }
    prepCarouselVideos(box);

    if (el.swiper) {
      el.swiper.destroy(false, false);
    }

    var opts = {
      centeredSlides: true,
      effect: 'slide',
      speed: 800,
      breakpoints: {
        768: { slidesPerView: 1, spaceBetween: 30 },
        1024: { slidesPerView: 1, spaceBetween: 40 },
      },
      on: {
        init: function () {
          syncVideos(el, this.activeIndex);
        },
        slideChange: function () {
          syncVideos(el, this.activeIndex);
        },
        slideChangeTransitionEnd: function () {
          syncVideos(el, this.activeIndex);
        },
      },
    };

    var pag = box.querySelector('.t1-nozzle-pagination');
    var prev = box.querySelector('.t1-nozzle-prev');
    var next = box.querySelector('.t1-nozzle-next');
    if (pag) {
      opts.pagination = { el: pag, clickable: true, dynamicBullets: false };
    }
    if (prev && next) {
      opts.navigation = { prevEl: prev, nextEl: next };
    }

    var sw = new Swiper(el, opts);
    box._t1Swiper = sw;

    guardVideoPlayback(el, function () {
      return sw.activeIndex;
    });

    loadSlideMedia(sw.slides[sw.activeIndex]);
    syncVideos(el, sw.activeIndex);
    box.dataset.t1Nozzle = '1';

    if (!box._t1ResizeBound) {
      box._t1ResizeBound = true;
      window.addEventListener('resize', function () {
        if (box._t1Swiper) {
          syncVideos(el, box._t1Swiper.activeIndex);
        }
      });
    }
  }

  /**
   * kv16：桌面端手风琴 + 切左图；移动端独立 Swiper（1.2 屏露出下一张）
   * 原内联于 A-Hilo.liquid，现统一收口到本文件
   */
  function initKv16(section) {
    if (!section || section.dataset.hiloKv16 === '1') {
      return;
    }

    var root = section.querySelector('[data-kv16-accordion]');
    var mediaRoot = section.querySelector('[data-kv16-media]');

    /**
     * 移动端轮播：对齐 kv14 / sec10family 的 slidesPerView 与间距
     * 导航按钮用本区块内的 .kv16-prev / .kv16-next，避免和其它轮播冲突
     */
    function initMobileSwiper() {
      var el = section.querySelector('.kv16-swiper');
      if (!el || el.dataset.kv16Swiper === '1') {
        return;
      }
      if (typeof Swiper === 'undefined') {
        return;
      }

      // 主题编辑器重载时先销毁旧实例
      if (el.swiper) {
        el.swiper.destroy(false, false);
      }

      new Swiper(el, {
        direction: 'horizontal',
        speed: 800,
        slidesPerView: 1.2,
        spaceBetween: 10,
        navigation: {
          nextEl: section.querySelector('.kv16-next'),
          prevEl: section.querySelector('.kv16-prev'),
        },
      });
      el.dataset.kv16Swiper = '1';
    }

    // 桌面端手风琴（移动端 DOM 仍在但被 .pc 隐藏，逻辑可保留）
    if (root && mediaRoot && !root.dataset.kv16AccInit) {
      var items = root.querySelectorAll('.kv16-acc-item');
      var mediaItems = mediaRoot.querySelectorAll('.kv16-media-item');

      /**
       * 切换左侧图片：按索引给对应 media-item 加 is-active
       * @param {string|number} index 与 data-kv16-img / data-kv16-media-index 对应
       */
      function switchMedia(index) {
        var target = String(index);
        mediaItems.forEach(function (el) {
          if (el.getAttribute('data-kv16-media-index') === target) {
            el.classList.add('is-active');
          } else {
            el.classList.remove('is-active');
          }
        });
      }

      /**
       * 按内容真实高度设置面板 max-height（展开）或归零（收起）
       * @param {Element} item 手风琴单项
       * @param {boolean} open 是否展开
       */
      function setPanelOpen(item, open) {
        var panel = item.querySelector('.kv16-acc-panel');
        var btn = item.querySelector('.kv16-acc-trigger');
        if (!panel) {
          return;
        }

        if (open) {
          item.classList.add('is-open');
          if (btn) {
            btn.setAttribute('aria-expanded', 'true');
          }
          panel.style.maxHeight = panel.scrollHeight + 'px';
          var imgIndex = item.getAttribute('data-kv16-img');
          if (imgIndex != null) {
            switchMedia(imgIndex);
          }
        } else {
          if (!item.classList.contains('is-open')) {
            panel.style.maxHeight = '0px';
            if (btn) {
              btn.setAttribute('aria-expanded', 'false');
            }
            return;
          }
          panel.style.maxHeight = panel.scrollHeight + 'px';
          void panel.offsetHeight;
          item.classList.remove('is-open');
          if (btn) {
            btn.setAttribute('aria-expanded', 'false');
          }
          panel.style.maxHeight = '0px';
        }
      }

      // 初始化：展开项写真实高度，其余收起
      items.forEach(function (item) {
        var panel = item.querySelector('.kv16-acc-panel');
        if (!panel) {
          return;
        }
        if (item.classList.contains('is-open')) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
          var imgIndex = item.getAttribute('data-kv16-img');
          if (imgIndex != null) {
            switchMedia(imgIndex);
          }
        } else {
          panel.style.maxHeight = '0px';
        }
      });

      // 窗口缩放后按内容重算已展开面板高度
      if (!root._kv16ResizeBound) {
        root._kv16ResizeBound = true;
        var resizeTimer;
        window.addEventListener('resize', function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () {
            items.forEach(function (item) {
              if (!item.classList.contains('is-open')) {
                return;
              }
              var panel = item.querySelector('.kv16-acc-panel');
              if (!panel) {
                return;
              }
              panel.style.maxHeight = panel.scrollHeight + 'px';
            });
          }, 100);
        });
      }

      items.forEach(function (item) {
        var trigger = item.querySelector('.kv16-acc-trigger');
        if (!trigger) {
          return;
        }

        trigger.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');
          items.forEach(function (el) {
            if (el !== item) {
              setPanelOpen(el, false);
            }
          });
          setPanelOpen(item, !isOpen);
        });
      });

      root.dataset.kv16AccInit = '1';
    }

    initMobileSwiper();
    section.dataset.hiloKv16 = '1';
  }

  /**
   * s23 / kv18「Why buy from Jirpet」卡片轮播
   * 配置对齐 cplus_pc_product.js // 23 begin；导航按钮 scoped 到本区块
   * @param {Element} section .kv18 根节点
   */
  function initS23(section) {
    if (!section || section.dataset.hiloS23 === '1') {
      return;
    }

    var el = section.querySelector('.s23');
    if (!el) {
      return;
    }

    if (!el.classList.contains('swiper')) {
      el.classList.add('swiper');
    }

    // 主题编辑器重载时先销毁旧实例，避免重复绑定
    if (el.swiper) {
      el.swiper.destroy(false, false);
    }

    var prev = section.querySelector('.sec23-prev');
    var next = section.querySelector('.sec23-next');

    var opts = {
      direction: 'horizontal',
      speed: 800,
      spaceBetween: 10,
      slidesPerView: 4,
      breakpoints: {
        320: {
          slidesPerView: 1.2,
          spaceBetween: 10,
        },
        769: {
          slidesPerView: 1.2,
          spaceBetween: 10,
        },
        1025: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    };

    // 移动端才渲染箭头（.wap.wap23）；有节点再挂 navigation
    if (prev && next) {
      opts.navigation = {
        nextEl: next,
        prevEl: prev,
      };
    }

    new Swiper(el, opts);
    section.dataset.hiloS23 = '1';
  }

  /** 初始化 #main-content 内全部区块 */
  function initAll() {
    var root = document.getElementById('main-content');
    if (!root || typeof Swiper === 'undefined') {
      return false;
    }

    initLazy();
    root.querySelectorAll('.carousel-container').forEach(initCarousel);
    root.querySelectorAll('.tray-container').forEach(initTray);
    root.querySelectorAll('.t1-container-nozzle').forEach(initNozzle);
    root.querySelectorAll('.kv16').forEach(initKv16);
    root.querySelectorAll('.kv18').forEach(initS23);
    return true;
  }

  /** load 后启动，Swiper 未就绪则重试 */
  function boot() {
    var tries = 0;
    (function run() {
      if (initAll() || tries >= 50) {
        return;
      }
      tries += 1;
      setTimeout(run, 100);
    })();
  }

  window.addEventListener('load', boot);
  if (document.readyState === 'complete') {
    boot();
  }

  /** 主题编辑器 section 重载 */
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target.querySelector('#main-content')) {
      return;
    }
    e.target.querySelectorAll('[data-t1-carousel],[data-t1-tray],[data-t1-nozzle]').forEach(function (node) {
      delete node.dataset.t1Carousel;
      delete node.dataset.t1Tray;
      delete node.dataset.t1Nozzle;
      if (node._t1ResizeObs) {
        node._t1ResizeObs.disconnect();
        node._t1ResizeObs = null;
      }
    });
    // 重置 kv16，便于重载后重新绑定手风琴 / 移动端 Swiper
    e.target.querySelectorAll('.kv16').forEach(function (node) {
      delete node.dataset.hiloKv16;
      var acc = node.querySelector('[data-kv16-accordion]');
      if (acc) {
        delete acc.dataset.kv16AccInit;
        acc._kv16ResizeBound = false;
      }
      var sw = node.querySelector('.kv16-swiper');
      if (sw) {
        delete sw.dataset.kv16Swiper;
        if (sw.swiper) {
          sw.swiper.destroy(false, false);
        }
      }
    });
    // 重置 s23 / kv18 卡片轮播
    e.target.querySelectorAll('.kv18').forEach(function (node) {
      delete node.dataset.hiloS23;
      var sw = node.querySelector('.s23');
      if (sw && sw.swiper) {
        sw.swiper.destroy(false, false);
      }
    });
    boot();
  });
})();

function openVideoModal() {
  var modal = document.getElementById('videoModal');
  var iframe = document.getElementById('videoFrame');
  if (!modal || !iframe) {
    return;
  }
  iframe.src =
    'https://player.vimeo.com/video/1103103715?badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1';
  modal.classList.add('active');
  document.body.style.overflow = 'hidden';
}

function closeVideoModal(event) {
  if (event && event.target !== event.currentTarget) {
    return;
  }
  var modal = document.getElementById('videoModal');
  var iframe = document.getElementById('videoFrame');
  if (!modal || !iframe) {
    return;
  }
  iframe.src = '';
  modal.classList.remove('active');
  document.body.style.overflow = '';
}

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    closeVideoModal();
  }
});
